import React from "react";
import NavBar from "../MyComponents/NavBar";
import "../MyComponents/reports.css";

function Ivrs() {
  return (
    <>
      <NavBar />
      <div>
        <iframe
          title="IVR-dashboard"
          src="https://app.powerbi.com/view?r=eyJrIjoiYTZiNDliOWMtMGQwNC00YTEyLTk4ODMtNTg2OTBkNTAwMmJmIiwidCI6ImIyYTViZGZhLTU0MzktNGUxMy04YTBlLWRmODIwMTJiMTQ2YSIsImMiOjZ9"
          id="reports"></iframe>
      </div>
    </>
  );
}

export default Ivrs;
